import React, { useMemo, useState } from "react";

export const MenuContext = React.createContext();

export const MenuProvider = (props) => {
    const [activeMenu, setActiveMenu] = useState("");
    const value = useMemo(() => ({ activeMenu, setActiveMenu }), [activeMenu]);

    return (
        <MenuContext.Provider value={value}>
            {props.children}
        </MenuContext.Provider>
    );
};
